import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h28A3.5 3.5 0 0 1 35.5 4v16a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 20z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#E8E8E8",
  d: "M.5 4A3.5 3.5 0 0 1 4 .5h28A3.5 3.5 0 0 1 35.5 4v16a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 20z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#2B2C2F",
  d: "M12 15.59v1.66h12v-1.66zm-1.125-7.7h3.431a1.435 1.435 0 0 1-.14-.357 1.64 1.64 0 0 1-.046-.393c0-.524.182-.968.545-1.33a1.81 1.81 0 0 1 1.33-.545c.315 0 .605.081.873.245.267.163.5.366.7.609l.418.56.418-.56a2.34 2.34 0 0 1 .695-.616 1.71 1.71 0 0 1 .878-.238c.523 0 .966.181 1.33.544.362.363.544.807.544 1.33 0 .138-.014.27-.043.394a1.212 1.212 0 0 1-.143.357h3.46v10.485h-14.25zM12 13.658h12V9.014h-4.33l1.532 2.094-.897.646-2.32-3.147-2.319 3.147-.897-.646 1.509-2.094H12zm3.995-5.77c.213 0 .39-.071.535-.215a.726.726 0 0 0 .215-.534.726.726 0 0 0-.215-.535.726.726 0 0 0-.535-.215.726.726 0 0 0-.534.215.726.726 0 0 0-.216.535c0 .212.072.39.216.534a.726.726 0 0 0 .534.216Zm3.98 0a.724.724 0 0 0 .535-.215.725.725 0 0 0 .216-.534.725.725 0 0 0-.216-.535.726.726 0 0 0-.534-.215.725.725 0 0 0-.534.215.726.726 0 0 0-.216.535c0 .212.072.39.216.534a.725.725 0 0 0 .534.216Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }